var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"marketplace-credentials-wrapper",attrs:{"fxCenter":""}},[_c('RegistrationActivationFlow',{attrs:{"waitingRoomData":_vm.waitingRoomData,"isReady":_vm.isReady,"isDelayed":_vm.isDelayed}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }